import React from 'react';

import TicketAssignmentsContainer from '@totem/components/ticketing/assignments/TicketAssignmentsContainer';
import TicketAssignmentsLayout, {
  TicketAssignmentsExtra,
} from '@totem/components/ticketing/assignments/TicketAssignmentsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const TicketAssignmentsPage = () => (
  <ContentLayout>
    <TicketAssignmentsContainer>
      <IBCard
        isCovered
        title="Ticket Assignments"
        extra={<TicketAssignmentsExtra />}
      >
        <TicketAssignmentsLayout />
      </IBCard>
    </TicketAssignmentsContainer>
  </ContentLayout>
);

export default TicketAssignmentsPage;
